import {collection, field} from "@fedeltapointofsale/data-client";
import {EmployeeReportSelectionData} from "../../controls/employee-report-selection-control.component";
import {ReportData} from "../../../../reports/report.data";

export class EmployeePerformanceReportData extends ReportData<EmployeePerformanceReportData> {
    @collection() groupBy: string[] = ["none"];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];

    @field hideEmployeesWithNoActivity: boolean = true;
}
